import { createPromiseClient } from '@bufbuild/connect-web';
import { BuildingManager } from '@/generated/msh/service/v1/structure_manager_connectweb';
import { GetBuildingsRequest } from '@/generated/msh/service/v1/structure_manager_pb';
import { transport } from '../transport';

const client = createPromiseClient(BuildingManager, transport);

export async function fetchBuildings(accountId, signal) {
  const response = await client.getBuildings(
    new GetBuildingsRequest({ accountId }),
    { signal }
  );

  return response.buildings;
}
